import $ from 'jquery';

const contextualMenuCleanup = function () {
    // cleanups for the mobile contextual menu
    var $mobileContextualMenus = $('.dcw_contextual-menu-mobile_list.contextualMenu');
    $mobileContextualMenus.each(function (index, contextualMenu) {
        var $contextualMenu = $(contextualMenu);

        // we will check only the links that don't have the 'js--hasContext' class, because:
        // 1. if this method is called before the contextualMenu(), then we will remove the showing links exceeding the limit
        // 2. if this method is called after the contextualMenu(), no link will have the class 'js--hasContext'
        // This is to ensure that, if this method gets called twice (one before and another after the call of contextualMenu()),
        // this won't remove too much links, leaving us with less then the maximum
        var $links = $contextualMenu.children('li:visible');
        var plusButton = $(".dcw_contextual-menu-mobile_btn");

        if($links.length === 0){
            // if we don't have any link, we will hide the opening button
            plusButton.addClass("dcw_visually-hidden");
        } else {
            // if we have some link, we will make sure the opening button will be shown
            plusButton.removeClass("dcw_visually-hidden");

            // if we have more than 7 links, then we need to add a special class
            if ($links.length > 7) {
                $contextualMenu.closest(".dcw_contextual-menu-mobile").addClass("dcw_contextual-menu-mobile--large");
            } else {
                $contextualMenu.closest(".dcw_contextual-menu-mobile").removeClass("dcw_contextual-menu-mobile--large");
            }

            // 10 is the maximum: if we have more than 10 links, we will remove the rest
            $links.each(function (i, link) {
                if(i < 10){
                    $(link).show();
                } else {
                    $(link).hide();
                }
            });
        }
    });

    // cleanups for the right column contextual menu
    var $desktopContextualMenus = $('.dcw_contextual-menu_wrapper.contextualMenu');
    $desktopContextualMenus.each(function (index, contextualMenu) {
        var $contextualMenu = $(contextualMenu);
        var $links = $contextualMenu.children('li:visible');
        var $contextualMenuWrapper = $contextualMenu.closest(".rightColumnContextualMenuWrapper");

        if($links.length === 0){
            // if we don't have any link, we will hide the component
            $contextualMenuWrapper.addClass("dcw_visually-hidden");
        } else {
            // if we have some link, we will make sure the opening button will be shown
            $contextualMenuWrapper.removeClass("dcw_visually-hidden");
        }
    });
};

export {contextualMenuCleanup};


// WEBPACK FOOTER //
// ./src/js/cms/pri/contextual-menu-cleanups.js